export default [
  {
    path: '/rules',
    name: 'rules',
    component: () =>
      import(/* webpackChunkName: "rules" */
        /* webpackMode: "lazy" */
        `./views/index.vue`)
  }
]
